// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReservationManagement-commonHeaderAdmin-cAqWf {
	position: fixed !important;
}

.ReservationManagement-adminLayout-r9d3S {
	padding-top: 64px !important;
}

.ReservationManagement-box-s8RwV h2 {
	font-size: 21px;
	font-weight: 600;
}

.ReservationManagement-exportLink-RzYHd {
	margin-bottom: -29px;
}

.ReservationManagement-blockCenter-NZqwF {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ReservationManagement-panelHeader-ecy8q {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ReservationManagement-currencyselect-CBgqi {
	width: 100%;
	margin-right: 0px;
}

.ReservationManagement-panelHeader-ecy8q {
	overflow: hidden;
	position: relative;
}

.ReservationManagement-mar0-naatM {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ReservationManagement-blockCenter-NZqwF {
		padding: 0px;
	}

	.ReservationManagement-panelHeader-ecy8q {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ReservationManagement-sideAdminPageWrapper-KawPh {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ReservationManagement-panelHeader-ecy8q {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ReservationManagement-table-qqyP6 {
	display: table;
}

.ReservationManagement-tableRow-X70XW {
	display: table-row;
}

.ReservationManagement-tableCell-P7SuQ {
	display: table-cell;
	float: none;
}

.ReservationManagement-formGroup-edcCd {
	margin-bottom: 6px;
}

.ReservationManagement-select-gnzyU {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ReservationManagement-noMargin-cRYdN {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ReservationManagement-exportLink-RzYHd {
	padding-top: 10px;
	padding-right: 10px;
}

.ReservationManagement-labelTextNew-lkK3v {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ReservationManagement-displayInline-xfOjE {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ReservationManagement-btnUPdate-YrCRw {
	display: inline-block;
}

.ReservationManagement-btnModalDelete-aifsw {
	display: inline-block;
	margin-left: 15px;
}

.ReservationManagement-radioBtn-GK1z1 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ReservationManagement-backgroundImg-DVHHb {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ReservationManagement-btnUPdate-YrCRw {
		display: block;
		margin-bottom: 12px;
	}

	.ReservationManagement-btnModalDelete-aifsw {
		display: block;
		margin-left: 0px;
	}

	.ReservationManagement-btnWidth-zwdnV {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ReservationManagement-bannerImageBg-PCrLK {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ReservationManagement-bannerDelete-oiOnF {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ReservationManagement-modalRoot-RaeLM {
	padding: 32px;
}

.ReservationManagement-modalBorderBottom-_jivF {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ReservationManagement-logInModalBody-YKb9I {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ReservationManagement-exportSection-kCQYR {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ReservationManagement-exportSectionGridSub-DD7JK {
	grid-template-columns: 50% 49% !important;
}

.ReservationManagement-exportText-Vvcvl {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ReservationManagement-exportLinkImg-IpXKr {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ReservationManagement-vtrMiddle-kC8CQ {
	vertical-align: middle;
}

.ReservationManagement-exportImg-zyhUP {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ReservationManagement-profileViewlabel-zOl3a {
	display: inline-block;
	width: 38%
}

.ReservationManagement-profileViewMainContent-TwiIU {
	display: inline-block;
	width: 62%;
}

.ReservationManagement-profileViewMain-zJaez {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ReservationManagement-profileViewInner-XqMsh {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ReservationManagement-profileImageSection-WNTpj {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ReservationManagement-lastviewInner-Tiq9a {
	padding: 10px;
}

.ReservationManagement-whyHostHoriLine-QhHHN {
	margin: 30px 0;
}

.ReservationManagement-tableGrid-DaxyQ {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ReservationManagement-headingContent-tob0l {
	font-size: 18px;
	font-weight: 500;
}

.ReservationManagement-refundTextColor-rzJRn {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ReservationManagement-dividerLine-_Uu_7 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ReservationManagement-smallContent-bQGXP {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ReservationManagement-sideAdminPageWrapper-KawPh {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ReservationManagement-sideAdminPageWrapper-KawPh {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ReservationManagement-exportSection-kCQYR {
		grid-template-columns: 100%;
	}

	.ReservationManagement-exportSectionGridSub-DD7JK {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ReservationManagement-profileViewlabel-zOl3a {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ReservationManagement-profileViewMainContent-TwiIU {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ReservationManagement-ChangeToUpperCase-C21Oa {
	text-transform: uppercase
}

.ReservationManagement-noBorder-LKyEd {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ReservationManagement-siteAdminHeading-TK1QE {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ReservationManagement-siteAdminSubHeading-I5Ax5 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ReservationManagement-adminFormDivider-FpRwC {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ReservationManagement-cancelBtn-cxpOi {
    color: var(--primary-link-foreground);
    cursor: pointer;
}

.ReservationManagement-cancelBtn-cxpOi:hover,
.ReservationManagement-cancelBtn-cxpOi:focus {
    text-decoration: underline;
}

.ReservationManagement-statusPill-_r_KO {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

/* Reservation State Pills */

.ReservationManagement-statusPill-_r_KO.ReservationManagement-pending-L_4gr {
  background-color: #fff3cd;
  color: #856404;
}

.ReservationManagement-statusPill-_r_KO.ReservationManagement-expired-_vQ5O {
  background-color: #f8d7da;
  color: #721c24;
}

.ReservationManagement-statusPill-_r_KO.ReservationManagement-approved-rMI4r {
  background-color: #d4edda;
  color: #155724;
}

.ReservationManagement-statusPill-_r_KO.ReservationManagement-declined-gEf0n {
  background-color: #f8d7da;
  color: #721c24;
}

.ReservationManagement-statusPill-_r_KO.ReservationManagement-completed-bZ95d {
  background-color: #d1ecf1;
  color: #0c5460;
}

.ReservationManagement-statusPill-_r_KO.ReservationManagement-cancelled-RZ3Y5 {
  background-color: #e2e3e5;
  color: #383d41;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ReservationManagement/ReservationManagement.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACrUA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,4BAA4B;;AAC5B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}","@import '../admin-common.css';\n\n.cancelBtn {\n    color: var(--primary-link-foreground);\n    cursor: pointer;\n}\n\n.cancelBtn:hover,\n.cancelBtn:focus {\n    text-decoration: underline;\n}\n\n.statusPill {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n/* Reservation State Pills */\n.statusPill.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.statusPill.expired {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.statusPill.approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.statusPill.declined {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.statusPill.completed {\n  background-color: #d1ecf1;\n  color: #0c5460;\n}\n\n.statusPill.cancelled {\n  background-color: #e2e3e5;\n  color: #383d41;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ReservationManagement-commonHeaderAdmin-cAqWf`,
	"adminLayout": `ReservationManagement-adminLayout-r9d3S`,
	"box": `ReservationManagement-box-s8RwV`,
	"exportLink": `ReservationManagement-exportLink-RzYHd`,
	"blockCenter": `ReservationManagement-blockCenter-NZqwF`,
	"panelHeader": `ReservationManagement-panelHeader-ecy8q`,
	"currencyselect": `ReservationManagement-currencyselect-CBgqi`,
	"mar0": `ReservationManagement-mar0-naatM`,
	"sideAdminPageWrapper": `ReservationManagement-sideAdminPageWrapper-KawPh`,
	"table": `ReservationManagement-table-qqyP6`,
	"tableRow": `ReservationManagement-tableRow-X70XW`,
	"tableCell": `ReservationManagement-tableCell-P7SuQ`,
	"formGroup": `ReservationManagement-formGroup-edcCd`,
	"select": `ReservationManagement-select-gnzyU`,
	"noMargin": `ReservationManagement-noMargin-cRYdN`,
	"labelTextNew": `ReservationManagement-labelTextNew-lkK3v`,
	"displayInline": `ReservationManagement-displayInline-xfOjE`,
	"btnUPdate": `ReservationManagement-btnUPdate-YrCRw`,
	"btnModalDelete": `ReservationManagement-btnModalDelete-aifsw`,
	"radioBtn": `ReservationManagement-radioBtn-GK1z1`,
	"backgroundImg": `ReservationManagement-backgroundImg-DVHHb`,
	"btnWidth": `ReservationManagement-btnWidth-zwdnV`,
	"bannerImageBg": `ReservationManagement-bannerImageBg-PCrLK`,
	"bannerDelete": `ReservationManagement-bannerDelete-oiOnF`,
	"modalRoot": `ReservationManagement-modalRoot-RaeLM`,
	"modalBorderBottom": `ReservationManagement-modalBorderBottom-_jivF`,
	"logInModalBody": `ReservationManagement-logInModalBody-YKb9I`,
	"exportSection": `ReservationManagement-exportSection-kCQYR`,
	"exportSectionGridSub": `ReservationManagement-exportSectionGridSub-DD7JK`,
	"exportText": `ReservationManagement-exportText-Vvcvl`,
	"exportLinkImg": `ReservationManagement-exportLinkImg-IpXKr`,
	"vtrMiddle": `ReservationManagement-vtrMiddle-kC8CQ`,
	"exportImg": `ReservationManagement-exportImg-zyhUP`,
	"profileViewlabel": `ReservationManagement-profileViewlabel-zOl3a`,
	"profileViewMainContent": `ReservationManagement-profileViewMainContent-TwiIU`,
	"profileViewMain": `ReservationManagement-profileViewMain-zJaez`,
	"profileViewInner": `ReservationManagement-profileViewInner-XqMsh`,
	"profileImageSection": `ReservationManagement-profileImageSection-WNTpj`,
	"lastviewInner": `ReservationManagement-lastviewInner-Tiq9a`,
	"whyHostHoriLine": `ReservationManagement-whyHostHoriLine-QhHHN`,
	"tableGrid": `ReservationManagement-tableGrid-DaxyQ`,
	"headingContent": `ReservationManagement-headingContent-tob0l`,
	"refundTextColor": `ReservationManagement-refundTextColor-rzJRn`,
	"dividerLine": `ReservationManagement-dividerLine-_Uu_7`,
	"smallContent": `ReservationManagement-smallContent-bQGXP`,
	"ChangeToUpperCase": `ReservationManagement-ChangeToUpperCase-C21Oa`,
	"noBorder": `ReservationManagement-noBorder-LKyEd`,
	"siteAdminHeading": `ReservationManagement-siteAdminHeading-TK1QE`,
	"siteAdminSubHeading": `ReservationManagement-siteAdminSubHeading-I5Ax5`,
	"adminFormDivider": `ReservationManagement-adminFormDivider-FpRwC`,
	"cancelBtn": `ReservationManagement-cancelBtn-cxpOi`,
	"statusPill": `ReservationManagement-statusPill-_r_KO`,
	"pending": `ReservationManagement-pending-L_4gr`,
	"expired": `ReservationManagement-expired-_vQ5O`,
	"approved": `ReservationManagement-approved-rMI4r`,
	"declined": `ReservationManagement-declined-gEf0n`,
	"completed": `ReservationManagement-completed-bZ95d`,
	"cancelled": `ReservationManagement-cancelled-RZ3Y5`
};
module.exports = ___CSS_LOADER_EXPORT___;
